import { Accordion } from "@prosolve/common-components-ui";
import ShipmentDetails from "./ShipmentDetails"
import ProductDetails from "./ProductDetails";

export default ({
  shipments,
  updateSbOrderData
}) => {
  const shipmentsBySku = shipments.reduce((acc,curr) => {
    const skus = curr.products.reduce((acc2,curr2) => { 
      acc2[curr2.reference_id] = 0; return acc2 
    }, [])
    Object.keys(skus).forEach(s => {
      if (!acc[s]) acc[s] = []
      acc[s].push(curr)
    })
    return acc
  }, [])

  return (<>
    <div style={{
      fontSize: '15px',
      fontWeight: 'bold',
      display: 'flex'
    }}>
      <div style={{ flex: 1 }}>
        {`Shipments by Product`}
      </div>
    </div>
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {Object.entries(shipmentsBySku).map(entry => {
        const sku = entry[0]
        const skuShipments = entry[1]
        const productKey = skuShipments[0].products.find(p => p.reference_id === sku)
        const quantityOverride = skuShipments.flatMap(s => s.products).filter(p => p.reference_id === sku).reduce((acc, curr) => acc + curr.quantity, 0)
        return (
          <Accordion key={sku} headerExpands={true} title={
            <ProductDetails key={productKey.id} product={productKey} quantityOverride={quantityOverride} shipmentQty={skuShipments.length} />
          }>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', borderLeft: 'solid 2px #0280c6', paddingLeft: '15px'}}>
              {skuShipments?.map(shipment => 
                <ShipmentDetails key={shipment.id} shipment={shipment} skuFilter={sku} updateSbOrderData={updateSbOrderData} />
              )}
            </div>
          </Accordion>
        )
    })}
    </div>
  </>)
}